var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0859 12.4536C15.3333 12.2062 15.3333 11.7938 15.0859 11.5464L9.75258 6.18557C9.47766 5.93814 9.06529 5.93814 8.81787 6.18557L8.18557 6.81787C7.93814 7.06529 7.93814 7.47766 8.18557 7.75258L12.4192 11.9863L8.18557 16.2474C7.93814 16.5223 7.93814 16.9347 8.18557 17.1821L8.81787 17.8144C9.06529 18.0619 9.47766 18.0619 9.75258 17.8144L15.0859 12.4536Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.b3870ab6427354215917221e55cce26f.svg";
export { ForwardRef as ReactComponent };